// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#model3DFrame {\n    height: 100%;\n    width: 100%;\n}\n#printQProductImage {\n    background-color: white;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
